export default "__VITE_ASSET__CP99qPOK__"